import React from 'react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-sky-50 py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 
            className="text-4xl font-bold text-slate-800 mb-4"
            style={{ fontFamily: 'Fredoka, sans-serif' }}
          >
            Terms & Conditions
          </h1>
          <p className="text-slate-600">Last updated: January 2026</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="prose prose-slate max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            1. Acceptance of Terms
          </h2>
          <p className="text-slate-600 mb-6">
            By accessing and using the Cartlixs website (cartlixs.store), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website or services.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            2. Use of Website
          </h2>
          <p className="text-slate-600 mb-4">You agree to use our website only for lawful purposes. You may not:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Use the website in any way that violates applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to our systems or networks</li>
            <li>Interfere with or disrupt the website or servers</li>
            <li>Use automated systems to access the website without permission</li>
            <li>Transmit any viruses, malware, or harmful code</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            3. Products and Pricing
          </h2>
          <p className="text-slate-600 mb-6">
            We strive to provide accurate product descriptions and pricing. However, we reserve the right to correct any errors and to change or update information at any time without prior notice. All prices are in US Dollars and are subject to change. We reserve the right to refuse or cancel any order if the product price is incorrectly displayed.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            4. Orders and Payment
          </h2>
          <p className="text-slate-600 mb-4">By placing an order, you represent that:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>You are at least 18 years old or have parental consent</li>
            <li>The information you provide is accurate and complete</li>
            <li>You are authorized to use the payment method provided</li>
          </ul>
          <p className="text-slate-600 mb-6">
            We reserve the right to refuse or cancel any order for any reason, including suspected fraud, unauthorized transactions, or violations of these terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            5. Shipping and Delivery
          </h2>
          <p className="text-slate-600 mb-6">
            Shipping times and costs are estimates and may vary. We are not responsible for delays caused by shipping carriers, customs, or circumstances beyond our control. Risk of loss and title for products pass to you upon delivery to the carrier.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            6. Returns and Refunds
          </h2>
          <p className="text-slate-600 mb-6">
            Our return and refund policy is outlined in our separate Refund & Return Policy page. By making a purchase, you agree to the terms of that policy.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            7. Intellectual Property
          </h2>
          <p className="text-slate-600 mb-6">
            All content on this website, including text, graphics, logos, images, and software, is the property of Cartlixs or its content suppliers and is protected by intellectual property laws. You may not reproduce, distribute, modify, or create derivative works without our express written consent.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            8. Product Safety
          </h2>
          <p className="text-slate-600 mb-6">
            All toys sold on Cartlixs comply with applicable US safety standards including CPSC regulations. Age recommendations are provided for guidance. Parents and guardians should always supervise children during play and check products for appropriate age suitability.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            9. Limitation of Liability
          </h2>
          <p className="text-slate-600 mb-6">
            To the fullest extent permitted by law, Cartlixs shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or products. Our total liability shall not exceed the amount you paid for the product in question.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            10. Indemnification
          </h2>
          <p className="text-slate-600 mb-6">
            You agree to indemnify and hold harmless Cartlixs, its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of the website or violation of these terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            11. Governing Law
          </h2>
          <p className="text-slate-600 mb-6">
            These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of New York, United States, without regard to its conflict of law provisions.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            12. Changes to Terms
          </h2>
          <p className="text-slate-600 mb-6">
            We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website after any changes constitutes acceptance of the new terms.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            13. Contact Information
          </h2>
          <p className="text-slate-600 mb-4">
            For questions about these Terms and Conditions, please contact us:
          </p>
          <ul className="list-none text-slate-600 space-y-2">
            <li><strong>Email:</strong> support@cartlixs.store</li>
            <li><strong>Phone:</strong> +1-888-435-6822</li>
            <li><strong>Address:</strong> 192 A 22nd St #4699, New York, NY 30272</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
